export default __webpack_public_path__ + "assets/images/success49e455fd1f75726cf4c7fc5678ac8cc3.gif";